import useEstimateCreation from "features/subscriptions/datahooks/useEstimateCreation";
import { formatPrice, parseEstimate } from "features/subscriptions/utils";

import Skeleton from "common/components/ui/Skeleton";
import type { Pricing } from "common/types";

import type { ReactNode } from "react";

export default function UserAndRentalSeatPricing({
  pricing,
  isRental,
}: {
  pricing: { addon: Pricing; plan: Pricing };
  isRental: boolean;
}) {
  const { estimateCreation } = useEstimateCreation({
    pricing,
    quantity: 1,
    isCustomerSubscription: false,
    couponId: undefined,
  });

  let content: ReactNode = <Skeleton className="w-8 h-4" />;

  if (estimateCreation) {
    const { pricePerItem } = parseEstimate(
      estimateCreation.invoice_estimate ||
        estimateCreation.next_invoice_estimate,
    );
    content = formatPrice(pricePerItem);
  }

  return (
    <div className="flex gap-x-1 text-button-xxs lg:text-button-sm flex-1 max-lg:justify-center max-lg:text-black-500">
      <span className="max-lg:text-xs-medium">{content}</span>/{" "}
      {isRental ? "account" : "seat"}
    </div>
  );
}
